var path = 'templates/dialogs/image.html';
var html = "<md-dialog aria-label=\"\"> <img ng-src=https://res-4.cloudinary.com/doyeq9idz/image/upload/{{id}}.jpg> </md-dialog> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/dialogs/image.html
// module id = 9
// module chunks = 0